import { Text } from "@/atoms"
import { ExclamationCircleOutlined } from "@/icons"

import styles from "./ConfirmModal.module.scss"

import type { ConfirmModalProps } from "."

export const CancelConfirmModal = (
  props: Omit<ConfirmModalProps, "entityName">
) => {
  const { title, width, t, messageAPI } = props

  return {
    title,
    width,
    destroyOnHidden: true,
    icon: <ExclamationCircleOutlined className={styles.warningIcon} />,
    content: (
      <Text data-testid="content-cancel-confirm-modal">
        {props.content || t("forms.messages.cancel.update")}
      </Text>
    ),
    okText: props.okText || t(props.keyOkText || "forms.buttons.cancel.update"),
    okButtonProps: {
      "data-testid": "ok-button-cancel-confirm-modal",
      ...props?.okButtonProps
    },
    cancelText: props.cancelText || t("forms.buttons.stay"),
    cancelButtonProps: {
      "data-testid": "cancel-button-cancel-confirm-modal",
      ...props?.cancelButtonProps
    },
    onOk: () => {
      try {
        props.onOk()
      } catch (err: any) {
        messageAPI.open({
          type: "error",
          content: err?.data?.displayMessage || err?.message || "Error"
        })
      }
    }
  }
}
